import { CHAT_USERS, ChatUser } from "../../db/chat";
import { DatabaseTimestampServerValue, RealtimeReference } from "../../db/common";
import { BaseDatabaseService } from "../DatabaseService";

/**
 * Shared Chat User Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class ChatUserService extends BaseDatabaseService<ChatUser> {
    protected getBasePath(): string {
        return CHAT_USERS;
    }

    //make it public for sub on change for FE
    public getEntityRef(userId: string): RealtimeReference {
        return super.getEntityRef(userId);
    }

    // @overwrite
    async delete(userId: string): Promise<void> {
        // return this.refChatUser(userId).remove();
        //only set the user status to deleted because we still want to be able to have minimum info to show in the chat
        const chatUser: Pick<ChatUser, 'status'> = {
            status: {
                state: 'deleted',
                lastChanged: DatabaseTimestampServerValue
            }
        }

        return super.update(userId, chatUser);
    }
}
